import { Flex } from "@chakra-ui/react";
import Notifications from "@root/components/notifications";
export const NotificationsPage = () => {
  return (
    <Flex minW={"100%"} position={"relative"} className="projectsDashboard">
      <Notifications />
    </Flex>
  );
};
